"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Item = exports.Container = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _InfiniteScroll = _interopRequireDefault(require("../../hocs/InfiniteScroll"));
var _Skeleton = _interopRequireDefault(require("./Skeleton"));
var _MemoizedWrapper = _interopRequireDefault(require("../../hocs/MemoizedWrapper"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  data: [],
  error: false,
  hasMore: false,
  wrapperTag: 'ul',
  itemWrapperTag: 'li',
  itemWrapperProps: {},
  listWrapperProps: {},
  endMessage: null,
  keyExtracted: 'id',
  direction: 'column',
  className: '',
  fetchNext() {},
  dataExtractor(item) {
    return item;
  }
};
function FlatList(props) {
  const {
    data,
    hasMore,
    fetchNext,
    scrollableTarget,
    component: Component,
    wrapperTag,
    listWrapperProps,
    itemWrapperTag,
    itemWrapperProps,
    dataExtractor,
    keyExtracted,
    endMessage,
    direction,
    styles,
    className
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const ListWrapper = (0, _react.useMemo)(() => Container.withComponent(wrapperTag), [wrapperTag]);
  const ItemWrapper = (0, _react.useMemo)(() => Item.withComponent(itemWrapperTag), [itemWrapperTag]);
  return /*#__PURE__*/_react.default.createElement(_InfiniteScroll.default, {
    dataLength: data === null || data === void 0 ? void 0 : data.length,
    hasMore: hasMore,
    direction: direction,
    next: fetchNext,
    scrollableTarget: scrollableTarget,
    endMessage: endMessage,
    className: className
  }, /*#__PURE__*/_react.default.createElement(ListWrapper, _extends({
    styles: styles,
    direction: direction
  }, listWrapperProps), data === null || data === void 0 ? void 0 : data.map((item, index) => /*#__PURE__*/_react.default.createElement(ItemWrapper, _extends({
    key: keyExtracted === 'index' ? index : item === null || item === void 0 ? void 0 : item[keyExtracted],
    index: index,
    value: String(keyExtracted === 'index' ? index : (item === null || item === void 0 ? void 0 : item[keyExtracted]) || ''),
    name: String(keyExtracted === 'index' ? index : (item === null || item === void 0 ? void 0 : item[keyExtracted]) || '')
  }, itemWrapperProps), /*#__PURE__*/_react.default.createElement(_MemoizedWrapper.default, null, /*#__PURE__*/_react.default.isValidElement(Component) ? (/*#__PURE__*/_react.default.cloneElement(Component, dataExtractor === null || dataExtractor === void 0 ? void 0 : dataExtractor(_objectSpread({}, item), index), index)) : /*#__PURE__*/_react.default.createElement(Component, _extends({}, dataExtractor === null || dataExtractor === void 0 ? void 0 : dataExtractor(_objectSpread({}, item), index), {
    index: index
  })))))));
}
const Container = exports.Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 15px;\n  flex-direction: ", ";\n\n  ", ";\n"])), _ref => {
  let {
    direction
  } = _ref;
  return direction;
}, _ref2 => {
  let {
    styles
  } = _ref2;
  return styles;
});
const Item = exports.Item = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  meta {\n    display: none;\n  }\n"])));
FlatList.Skeleton = _Skeleton.default;
var _default = exports.default = FlatList;